import type {
  ContractDetail,
  ContractDto,
  QuoteCreateInput,
  QuoteDto,
} from '@expeditor/shared';
import { apiClient } from './client';

export const quotesApi = {
  async listForOrder(orderId: string): Promise<QuoteDto[]> {
    const { data } = await apiClient.get<QuoteDto[]>(`/orders/${orderId}/quotes`);
    return data;
  },
  async createForOrder(orderId: string, dto: QuoteCreateInput): Promise<QuoteDto> {
    const { data } = await apiClient.post<QuoteDto>(`/orders/${orderId}/quotes`, dto);
    return data;
  },
  async accept(id: string): Promise<{ quote: QuoteDto; contract: ContractDto }> {
    const { data } = await apiClient.post<{ quote: QuoteDto; contract: ContractDto }>(
      `/quotes/${id}/accept`,
    );
    return data;
  },
  async reject(id: string): Promise<QuoteDto> {
    const { data } = await apiClient.post<QuoteDto>(`/quotes/${id}/reject`);
    return data;
  },
  async revoke(id: string): Promise<QuoteDto> {
    const { data } = await apiClient.post<QuoteDto>(`/quotes/${id}/revoke`);
    return data;
  },
};

export const contractsApi = {
  async list(): Promise<Array<ContractDto & { orderNumber: string; cargoName: string }>> {
    const { data } = await apiClient.get<
      Array<ContractDto & { orderNumber: string; cargoName: string }>
    >('/contracts');
    return data;
  },
  async getOne(id: string): Promise<ContractDetail> {
    const { data } = await apiClient.get<ContractDetail>(`/contracts/${id}`);
    return data;
  },
};
